import React, { useState } from "react";
import Sidenavbar from "../Sidenavbar";
import Topbar from "../Topbar";
import "../../styles/CommonStyle.scss";
import "../../styles/Products.scss";
import { Form } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import Select from "react-select";
import productimg from "../../images/products/headset.png";
import productimg1 from "../../images/products/MouseWired.png";
import { optionsPageSizeList } from "../DropdownsData";
import AddProductmodel from "./AddProductmodel";
import EditProductModel from "./EditProductModel";
import ViewProductDetails from "./ViewProductDetails";
import SbTableHeader from "../SbTables/SbTableHeader";

function Products() {
  let userDetails = JSON.parse(sessionStorage.getItem("usdtls"));

  const travelizeAuth = {
    "Content-Type": "application/json",
    Travelize_Authentication: userDetails,
  };

  const [toggleshift, setToggleshift] = useState({ style: "" });
  const [show, setShow] = useState(false);
  const [menuCollapse, setMenuCollapse] = useState(false);
  const [editproductmodel, setEditproductmodel] = useState(false);
  const [viewProductDetail, setViewProductDetail] = useState(false);

  let tableHeader = [
    "PRODUCT NAME",
    "CODE",
    "CATEGORY",
    "SUB CATEGORY",
    "SIZE",
    "DIMENSION (H x W x L)",
    "WEIGHT",
    "MRP",
    "ACTION"
  ]

  const toggleMenu = () => {
    if (menuCollapse === true) {
      setMenuCollapse(false);
      setToggleshift({ style: "" });
    } else {
      setMenuCollapse(true);
      setToggleshift({ style: "toggle-shift-left" });
    }
  };

  // PAGINATION START
  const [PageSize, setPageSize] = useState(20);
  const [pageCount, setPageCount] = useState(3);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalemployee, setTotalemployee] = useState("");
  const [pageDataSize, setPageDataSize] = useState("");
  const [itemOffset, setItemOffset] = useState(1);
  const handlePageClick = (data) => {
    setCurrentPage(data.selected + 1);
  };
  const pageDataFrom = currentPage * PageSize - PageSize + 1;
  const pageDataTill = pageDataFrom + pageDataSize - 1;
  // console.log("From:", pageDataFrom, "TO", pageDataTill);
  // PAGINATION END

  const handleClose = () => {
    setShow(false);
    setEditproductmodel(false);
    setViewProductDetail(false);
  };

  return (
    <div id="main-page">
      {/* SIDEBAR START */}
      <Sidenavbar menuCollapse={menuCollapse} toggleshift={toggleshift} />
      {/* SIDEBAR END */}

      {/* TOPBAR START */}
      <Topbar
        toggleMenu={toggleMenu}
        menuCollapse={menuCollapse}
        toggleshift={toggleshift}
      />
      {/* TOPBAR END */}

      {/* MAIN BODY START */}
      <div className="page-wrapper">
        {/* PAGE CONTENT START */}
        <div className={`main-body ${toggleshift.style}`}>
          <div className="page-content">
            {/* USER TABLE START */}
            <div className="products-table">
              <div className="seleting-menus">
                <div className="page-title">PRODUCTS (2)</div>

                <div className="page-top-bar-dropdowns">
                  <Select
                    className="react-select-container-list"
                    classNamePrefix="react-select-list"
                    // options={MOTList}
                    placeholder="Select Product"
                    // value={MotId === "" ? "" : MOTList.value}
                    // onInputChange={MOTList.label}
                    // onChange={(data) => setMotId(data.value)}
                    isSearchable={true}
                    // isClearable={true}
                  />

                  <Select
                    className="react-select-container-list"
                    classNamePrefix="react-select-list"
                    // options={MOTList}
                    placeholder="Select Category"
                    // value={MotId === "" ? "" : MOTList.value}
                    // onInputChange={MOTList.label}
                    // onChange={(data) => setMotId(data.value)}
                    isSearchable={true}
                    // isClearable={true}
                  />

                  <Select
                    className="react-select-container-list"
                    classNamePrefix="react-select-list"
                    // options={MOTList}
                    placeholder="Sub-Category"
                    // value={MotId === "" ? "" : MOTList.value}
                    // onInputChange={MOTList.label}
                    // onChange={(data) => setMotId(data.value)}
                    isSearchable={true}
                    // isClearable={true}
                  />

                  <Select
                    className="react-select-container-list"
                    classNamePrefix="react-select-list"
                    // options={MOTList}
                    placeholder="Price"
                    // value={MotId === "" ? "" : MOTList.value}
                    // onInputChange={MOTList.label}
                    // onChange={(data) => setMotId(data.value)}
                    isSearchable={true}
                    // isClearable={true}
                  />

                  <button
                    type="button"
                    className="btn btn-search-track"
                    // onClick={clearSerachBySelect}
                  >
                    <span className="btn-inline-item d-flex">
                      <i className="fa fa-eraser"> </i>
                      <h6>Clear</h6>
                    </span>
                  </button>

                  <Select
                    className="react-select-container-list"
                    classNamePrefix="react-select-list"
                    // defaultValue={optionsRoleList[0].label}
                    options={optionsPageSizeList}
                    placeholder="Show Per Page"
                    value={optionsPageSizeList.value}
                    onInputChange={optionsPageSizeList.label}
                    onChange={(data) => setPageSize(data.value)}
                    isSearchable={true}
                  />

                  <button
                    type="button"
                    className="btn btn-add-product"
                    onClick={() => setShow(!show)}
                  >
                    <span className="btn-inline-item d-flex">
                      <i className="fa fa-plus-square" /> &nbsp;
                      <h6>Add New</h6>
                    </span>
                  </button>
                </div>
              </div>
              <div className="table-responsive products-scrollbar">
                <table className="table products-table-data">
                  <SbTableHeader tableHeader={tableHeader} />
                  <tbody>
                    <tr className="product-table-row-data">
                      <td>
                        <p className="row-img-product">
                          <span className="product-img-box">
                            <img
                              className="row-product-images"
                              src={productimg}
                              alt="Product Images"
                            />{" "}
                          </span>
                          &nbsp; &nbsp;{" "}
                          <p>
                            <strong>Bluetooth Headset</strong> <br />
                            {/* <small>SN : LM123456465</small> */}
                          </p>
                        </p>
                      </td>
                      <td>H-0581</td>
                      <td>Electronics</td>
                      <td>Headset</td>
                      <td>Medium</td>
                      <td>20mm x 1209mm x 1220mm</td>
                      <td>500gm</td>
                      <td>1,800.00</td>
                      <td>
                        <button
                          onClick={() => setEditproductmodel(!editproductmodel)}
                          className="btn product-edit-link"
                        >
                          <i className="bi bi-pencil-fill"></i> Edit
                        </button>
                        <button
                          onClick={() =>
                            setViewProductDetail(!viewProductDetail)
                          }
                          className="btn product-edit-link"
                        >
                          <i className="fa fa-eye"></i> View
                        </button>
                      </td>
                    </tr>
                    <tr className="product-table-row-data">
                      <td>
                        <p className="row-img-product">
                          <span className="product-img-box">
                            <img
                              className="row-product-images"
                              src={productimg1}
                              alt="Product Images"
                            />{" "}
                          </span>
                          &nbsp; &nbsp;{" "}
                          <p>
                            <strong>Wired Mouse</strong> <br />
                            {/* <small>SN : LM123456465</small> */}
                          </p>
                        </p>
                      </td>
                      <td>CA-0032</td>
                      <td>Electronics</td>
                      <td>Computer Accessories</td>
                      <td>Medium</td>
                      <td>20mm x 1209mm x 1220mm</td>
                      <td>340gm</td>
                      <td>599.00</td>
                      <td>
                        <button
                          onClick={() => setEditproductmodel(!editproductmodel)}
                          className="btn product-edit-link"
                        >
                          <i className="bi bi-pencil-fill"></i> Edit
                        </button>
                        <button
                          onClick={() =>
                            setViewProductDetail(!viewProductDetail)
                          }
                          className="btn product-edit-link"
                        >
                          <i className="fa fa-eye"></i> View
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            {/* USER TABLE END */}

            <div className="download-and-pagination">
              <button
                type="button"
                className="btn btn-download-excel"
                // onClick={exportExcelActiivity}
              >
                <i className="fa fa-download" /> &nbsp; Download
              </button>
              <span className="user-pagination">
                <ReactPaginate
                  breakLabel="..."
                  nextLabel={<i className="fa fa-angle-double-right" />}
                  onPageChange={handlePageClick}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={2}
                  pageCount={pageCount}
                  previousLabel={<i className="fa fa-angle-double-left" />}
                  renderOnZeroPageCount={null}
                  containerClassName={"pagination"}
                  subContainerClassName={"pages pagination"}
                  activeClassName={"active"}
                  disabledClassName={"disabled"}
                />
              </span>
            </div>

            {/* ADD PRODUCT MODEL START */}
            <AddProductmodel show={show} handleClose={handleClose} />
            {/* ADD PRODUCT MODEL END */}

            {/* EDIT PRODUCT MODEL START */}
            {editproductmodel ? (
              <EditProductModel
                editproductmodel={editproductmodel}
                handleClose={handleClose}
              />
            ) : (
              ""
            )}
            {/* EDIT PRODUCT MODEL END */}

            {/* VIEW PRODUCT MODEL START */}
            {viewProductDetail ? (
              <ViewProductDetails
                viewProductDetail={viewProductDetail}
                handleClose={handleClose}
              />
            ) : (
              ""
            )}
            {/* VIEW PRODUCT MODEL END */}

            {/* PAGE CONTENT END*/}
          </div>
        </div>

        {/* MAIN BODY END */}
      </div>
    </div>
  );
}

export default Products;
